<template>
  <div>
    <b-container>
      <!-- <img v-bind:src="logoUrl" /> -->
        <h1>Diploma Digital</h1>
        <b-row class='returnDados'>
            <!-- <label for='inputCod'>Código</label> -->
            <b-input-group class='mt-3' id='g_pesquisa'>
                <b-form-input id='inputCod' v-model='codigo' v-on:keyup='onKeyPress' :placeholder='phInput'></b-form-input>
                <b-input-group-append>
                    <b-button v-on:click='buscar' variant='outline-success'>Buscar</b-button>
                    <b-button v-on:click='cancelar' variant='outline-danger'>Cancelar</b-button>
                </b-input-group-append>
            </b-input-group>
            <!--<b-form-group label='' v-slot="{ ariaDescribedby }" id='g_filtro'>
              <b-form-radio-group
                class='chkFiltroPesquisa'
                v-model='chkSelected'
                :options='chkOptions'
                :aria-describedby="ariaDescribedby"
                button-variant="outline-primary"
                buttons
                v-on:change='mudaPlaceholderInput'
              ></b-form-radio-group>
            </b-form-group>-->
        </b-row>
        <div v-if='enableCursoSelect == true'>
          <b-row>
            <b-input-group class='mt-3'>
              <b-form-select id='frm-cursos' v-model="cursoCodSelected" :options="cursoOptions"></b-form-select>
              <b-button
                variant='outline-primary'
                v-on:click='buscaAlunoDaLista(cursoCodSelected)'
              ><b-icon icon='search'></b-icon>
              </b-button>
            </b-input-group>
          </b-row>
        </div>
        <div v-if='anulErroOficio == true'>
          <b-card>
            <b-card bg-variant="danger" text-variant="white" header="Diploma Anulado" class="text-center">
              <b-card-text>{{this.msgAnulacao}}</b-card-text>
            </b-card>
            <b-button v-on:click='disableFormAluno' variant='primary' class='line_dip'>
                <b-icon icon='arrow-left'></b-icon>  Voltar
            </b-button>
          </b-card>
        </div>
        <div v-if='anulErroFato == true'>
          <b-card>
            <b-card bg-variant="danger" text-variant="white" header="Diploma Anulado" class="text-center">
              <b-card-text>
                {{this.msgAnulacao}}<br><br><b>Motivo:</b> "{{this.items.motivo_anulacao}}"
              </b-card-text>
            </b-card>
            <b-button v-on:click='disableFormAluno' variant='primary' class='line_dip'>
              <b-icon icon='arrow-left'></b-icon>  Voltar
            </b-button>
          </b-card>
        </div>
        <div v-if='dDisable == true'>
            <b-card>
            <b-row class='line_dip'>
                <b-col class='returnDados' lg='3'>
                    <label for='inputNome'>Nome</label>
                    <b-form-input id='inputNome' v-model='items.nome' disabled></b-form-input>
                </b-col>
                <b-col class='returnDados' lg='3'>
                    <label for='inputCPF'>CPF</label>
                    <b-form-input id='inputCPF' v-model='items.cpf' disabled></b-form-input>
                </b-col>
                <b-col class='returnDados' lg='6'>
                    <label for='inputCurso'>Curso</label>
                    <b-form-input id='inputCurso' v-model='items.curso' disabled></b-form-input>
                </b-col>
            </b-row>
            <b-row class='line_dip'>
                <b-col class='returnDados' lg='3'>
                    <label for='inputDtIngresso'>Data de Ingresso</label>
                    <b-form-input type='date' id='inputDtIngresso' v-model='items.dt_ingresso' disabled></b-form-input>
                </b-col>
                <b-col class='returnDados' lg='3'>
                    <label for='inputDtPub'>Data Public. Diploma</label>
                    <b-form-input type='date' id='inputDtPub' v-model='items.dt_public_dip' disabled></b-form-input>
                </b-col>
                <b-col class='returnDados' lg='3'>
                    <label for='inputDtPub'>Data Conclusão</label>
                    <b-form-input type='date' id='inputDtPub' v-model='items.dt_conclusao' disabled></b-form-input>
                </b-col>
                <b-col class='returnDados' lg='3'>
                    <label for='inputSitDip'>Situação Diploma</label>
                    <b-form-input id='inputSitDip' v-model='items.sit_diploma' disabled></b-form-input>
                </b-col>
            </b-row>
            <b-row class='line_dip'>
                <b-col class='returnDados' lg='6'>
                    <label for='inputNomeExp'>Nome da Expedidora</label>
                    <b-form-input id='inputNomeExp' v-model='items.nome_expedidora' disabled></b-form-input>
                </b-col>
                <b-col class='returnDados' lg='3'>
                    <label for='inputDtExp'>Data de Expedição</label>
                    <b-form-input type='date' id='inputDtExp' v-model='items.dt_expedicao' disabled></b-form-input>
                </b-col>
                <b-col class='returnDados' lg='3'>
                    <label for='inputNumExp'>Número expedição</label>
                    <b-form-input id='inputNumExp' v-model='items.num_expedicao' disabled></b-form-input>
                </b-col>
            </b-row>
            <b-row class='line_dip'>
                <b-col class='returnDados' lg='6'>
                    <label for='inputNomeReg'>Nome da Registradora</label>
                    <b-form-input id='inputNomeReg' v-model='items.nome_registradora' disabled></b-form-input>
                </b-col>
                <b-col class='returnDados' lg='3'>
                    <label for='inputNumReg'>Número de Registro</label>
                    <b-form-input id='inputNumReg' v-model='items.num_registro' disabled></b-form-input>
                </b-col>
                <b-col class='returnDados' lg='3'>
                    <label for='inputDtReg'>Data de Registro</label>
                    <b-form-input type='date' id='inputDtReg' v-model='items.dt_registro' disabled></b-form-input>
                </b-col>
            </b-row>
            <b-row class='line_dip'>
              <b-col v-if='this.downloadsEnabled == true'>
                <b-dropdown text="Download" variant="outline-primary" class="m-2">
                  <b-dropdown-item v-if='this.items.xml_publico != null ' v-on:click='download(true)'>XML</b-dropdown-item>
                  <b-dropdown-item v-if='this.items.rvdd != null ' v-on:click='download(false)'>RVDD</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col>
                <b-button v-on:click='disableFormAluno' variant='primary' class='line_dip'>
                  <b-icon icon='arrow-left'></b-icon>  Voltar
                </b-button>
              </b-col>
            </b-row>
            <div v-if='anulErroFatoAtivo == true'>
              <div class="accordion" role="tablist">
                <b-button block v-b-toggle.clps-err-anul variant="danger">Aviso</b-button>
                <b-collapse id='clps-err-anul' role="tabpanel">
                  <b-card bg-variant="danger" text-variant="white" class="text-center">
                    <b-card-text>
                      {{this.msgAnulacao}}<br><br><b>Motivo:</b> "{{this.items.motivo_anulacao}}"
                    </b-card-text>
                  </b-card>
                </b-collapse>
              </div>
            </div>
        </b-card>
        </div>
        <!-- tabela -->
        <div v-if='enableNameTbl == true'>
          <b-row>
            <b-table
              :items='tblItems'
              :fields='tblFields'
              responsive='sm'
              ref='tableAlunos'
              head-variant='light'
              :hover='true'
              :sticky-header='true'
              :bordered='true'
              :no-border-collapse='true'
            >
              <template #cell(acao)="row">
                <b-button
                  @click='buscaAlunoDaLista(row.item.codigo)'
                  variant='primary'
                ><b-icon icon='search'></b-icon></b-button>
              </template>
            </b-table>
          </b-row>
        </div>
    </b-container>
  </div>
</template>
<script>

import axios from 'axios'

// Util de formatação de data
function formatShortDate (dateStr) {
  let d = new Date(dateStr + 'T00:00:00')
  let day = d.getDate()
  let month = d.getMonth() + 1
  let year = d.getFullYear()

  if (day < 10) day = '0' + day
  if (month < 10) month = '0' + month

  return (day + '/' + month + '/' + year)
}

export default {
  name: 'DadosDiploma',
  data () {
    return {
      phInput: 'Código',
      inputMask: '',
      chkSelected: 'codigo',
      chkOptions: [
        { text: 'Código', value: 'codigo' },
        { text: 'Nome', value: 'nome' },
        { text: 'CPF', value: 'cpf' }
      ],
      tblItems: [],
      tblFields: [
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'cpf', label: 'CPF' },
        { key: 'curso', label: 'Curso', sortable: true },
        { key: 'num_registro', label: 'Número do Registro' },
        { key: 'dt_expedicao', label: 'Data de Expedição' },
        { key: 'situacao', label: 'Situação' },
        { key: 'acao', label: '' }
      ],
      cursoCodSelected: null,
      cursoOptions: [
        { value: null, text: 'Selecione um curso.', disabled: 'true' }
      ],
      dDisable: false,
      enableNameTbl: false,
      enableCursoSelect: false,
      codigo: null,
      downloadsEnabled: false,
      anulErroFato: false,
      anulErroFatoAtivo: false,
      anulErroOficio: false,
      msgAnulacao: '',
      fullPage: false,
      fadeSpeed: 0.2,
      items: {
        id_curso_aluno: '',
        nome: '',
        cpf: '',
        curso: '',
        dt_ingresso: '',
        dt_conclusao: '',
        dt_public_dip: '',
        sit_diploma: '',
        nome_expedidora: '',
        dt_expedicao: '',
        num_expedicao: '',
        nome_registradora: '',
        num_registro: '',
        dt_registro: '',
        hr_erro_fato: '',
        dt_erro_fato: '',
        dt_erro_oficio: '',
        hr_erro_oficio: '',
        dt_ativacao: '',
        motivo_anulacao: '',
        xml_publico: '',
        rvdd: ''
      },
      logoUrl: '',
      instituicao: null
    }
  },
  mounted () {
    this.instituicao = null
    axios.post(process.env.ROOT_API.concat('instituicao'), {})
      .then(response => {
        this.instituicao = response.data[0]

        // var aElement = document.createElement('a')

        // aElement.setAttribute('href', 'data:image/bmp;base64,' + btoa(this.instituicao.LOGOMARCA))
        // aElement.setAttribute('download', `teste.bmp`)

        // this.logoUrl = 'data:image/bmp;base64,' + btoa(this.instituicao.LOGOMARCA)
      }).catch(error => {
        console.log(error)
        this.makeToast('danger', 'Problemas ao conectar com o servidor.', 'Atenção')
      })
  },
  methods: {
    buscar: function (event) {
      this.tblItems = []
      this.disableFormAluno()
      if (this.codigo != null && this.codigo.trim().length > 0) {
        document.getElementById('inputCod').blur()
        var vm = this
        let loader = this.$loading.show(this.getLoaderPropriedades())

        axios.post(process.env.ROOT_API.concat('diploma'), {codigo: this.codigo.trim(), chkSelected: this.chkSelected})
          .then(response => {
            if (response.status === 200 && !response.data.msg) {
              if (this.chkSelected !== 'nome') {
                if (this.chkSelected === 'codigo') {
                  this.buildAlunoFields(response)
                } else if (this.chkSelected === 'cpf') {
                  if (response.data.length > 0) {
                    this.buildTableCursos(response)
                  } else {
                    vm.makeToast('default', 'CPF Não encontrado.', 'Atenção')
                  }
                } else if (response.data.length === 0 && this.chkSelected === 'cpf') {
                  vm.dDisable = false
                  vm.makeToast('danger', 'CPF Não encontrado.', 'Atenção')
                }
              } else {
                if (response.data.length > 0) {
                  this.buildTableAlunos(response)
                  vm.dDisable = false
                } else {
                  vm.makeToast('default', 'Não foi encontrado nenhum diploma para o nome informado.', 'Atenção')
                }
              }
            } else {
              vm.dDisable = false
              let msg = response.data.msg
              if (this.chkSelected === 'nome') msg = 'Não foi encontrado nenhum diploma para o nome informado.'
              vm.makeToast('default', msg, 'Atenção')
            }
            loader.hide()
          }).catch(error => {
            vm.dDisable = false
            console.log(error)
            vm.makeToast('danger', 'Problemas ao conectar com o servidor.', 'Atenção')
            loader.hide()
          })
      } else {
        this.dDisable = false
        this.makeToast('default', 'Insira o código do diploma.', 'Atenção')
      }
      document.getElementById('inputCod').focus()
    },
    cancelar: function (event) {
      this.codigo = ''
      this.dDisable = false
      this.enableNameTbl = false
      this.anulErroOficio = false
      this.anulErroFato = false
      this.anulErroFatoAtivo = false
      this.enableCursoSelect = false
      this.tblItems = []
      this.cursoCodSelected = ''
    },
    makeToast (variant = null, MSG, Title) {
      this.$bvToast.toast(MSG, {
        title: Title,
        variant: variant,
        solid: true
      })
    },
    onKeyPress (event) {
      if (event.key === 'Enter') {
        this.buscar()
      } else if (event.key === 'Escape') {
        this.cancelar()
      }
    },
    download (isXML) {
      var aElement = document.createElement('a')

      if (isXML) {
        this.items.xml_publico = this.replaceAll(this.items.xml_publico, 'encoding="ISO-8859-1" ', '')

        aElement.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(this.items.xml_publico))
        aElement.setAttribute('download', `xml ${this.items.id_curso_aluno}`)
      } else {
        aElement.setAttribute('href', 'data:application/octet-stream;base64,' + btoa(this.items.rvdd))
        aElement.setAttribute('download', `pdf ${this.items.id_curso_aluno}.pdf`)
      }

      if (document.createEvent) {
        var event = document.createEvent('MouseEvents')
        event.initEvent('click', true, true)
        aElement.dispatchEvent(event)
      } else {
        aElement.click()
      }
    },
    replaceAll (stringOriginal, old, novo) {
      do {
        let hasOld = stringOriginal.indexOf(old)
        if (hasOld < 0) {
          break
        } else {
          stringOriginal = stringOriginal.replace(old, novo)
        }
      } while (true)
      return stringOriginal
    },
    mudaPlaceholderInput () {
      switch (this.chkSelected) {
        case 'cpf':
          this.phInput = 'CPF'
          this.codigo = ''
          this.inputMask = '###.###.###-##'
          this.enableNameTbl = false
          if (this.cursoOptions.length > 1 && this.dDisable === false) {
            this.enableCursoSelect = true
          }
          break
        case 'nome':
          this.phInput = 'Nome'
          this.codigo = ''
          this.inputMask = ''
          if (this.tblItems.length > 0 && this.dDisable === false) {
            this.enableNameTbl = true
          }
          this.enableCursoSelect = false
          break
        case 'codigo':
          this.phInput = 'Código'
          this.codigo = ''
          this.inputMask = ''
          this.enableNameTbl = false
          this.enableCursoSelect = false
          break
        default:
          this.phInput = ''
          this.codigo = ''
          this.inputMask = ''
          this.enableNameTbl = false
          this.enableCursoSelect = false
          break
      }
    },
    buildTableAlunos: function (response) {
      var vm = this
      vm.tblItems = []
      for (var i = 0; i < response.data.length; i++) {
        vm.tblItems.push({
          id_curso_aluno: response.data[i].ID_CURSO_ALUNO,
          nome: response.data[i].NOME_PESSOA,
          cpf: response.data[i].CPF,
          curso: response.data[i].CURSO,
          num_registro: response.data[i].NUM_REGISTRO,
          dt_expedicao: formatShortDate(response.data[i].DT_EXP_DIPLOMA),
          situacao: response.data[i].SITUACAO,
          codigo: response.data[i].CODIGO_VALIDACAO
        })
      }
      vm.enableNameTbl = true
    },
    buildTableCursos: function (response) {
      var vm = this
      vm.cursoOptions = [{ value: null, text: 'Selecione um curso.', disabled: 'true' }]
      vm.cursoCodSelected = null
      for (var i = 0; i < response.data.length; i++) {
        vm.cursoOptions.push({
          value: response.data[i].CODIGO_VALIDACAO,
          text: response.data[i].CURSO
        })
      }
      vm.enableCursoSelect = true
    },
    buscaAlunoDaLista: function (codigo) {
      if (codigo !== undefined && codigo !== '' && codigo !== null) {
        var vm = this
        let loader = this.$loading.show(this.getLoaderPropriedades())

        axios.post(process.env.ROOT_API.concat(`diploma`), {codigo: codigo})
          .then(response => {
            if (response.status === 200 && !response.data.msg) {
              this.buildAlunoFields(response)
            } else {
              vm.dDisable = false
              vm.makeToast('default', response.data.msg, 'Atenção')
            }
            loader.hide()
          }).catch(error => {
            vm.dDisable = false
            console.log(error)
            vm.makeToast('danger', 'Problemas ao conectar com o servidor.', 'Atenção')
            loader.hide()
          })
      } else {
        this.dDisable = false
        this.makeToast('default', 'Selecione um diploma.', 'Atenção')
      }
    },
    disableFormAluno () {
      this.dDisable = false
      this.anulErroFato = false
      this.anulErroFatoAtivo = false
      this.anulErroOficio = false

      if (this.tblItems.length > 0 && this.chkSelected === 'nome') {
        this.enableNameTbl = true
      } else {
        this.enableNameTbl = false
      }

      if (this.cursoOptions.length > 1 && this.chkSelected === 'cpf') {
        this.enableCursoSelect = true
      } else {
        this.enableCursoSelect = false
      }
    },
    buildAlunoFields (response) {
      var vm = this

      if (response.data.length > 0) {
        vm.dDisable = true
        vm.anulErroOficio = false
        vm.anulErroFato = false
        vm.anulErroFatoAtivo = false
        vm.enableNameTbl = false
        vm.enableCursoSelect = false
        vm.items.id_curso_aluno = response.data[0].ID_CURSO_ALUNO
        vm.items.nome = response.data[0].NOME_PESSOA
        vm.items.cpf = response.data[0].CPF
        vm.items.curso = response.data[0].EMEC_CURSO
        vm.items.dt_ingresso = response.data[0].DT_INGRESSO
        vm.items.dt_conclusao = response.data[0].DT_CONCLUSAO
        vm.items.dt_public_dip = response.data[0].DT_EXP_DIPLOMA
        vm.items.sit_diploma = response.data[0].SITUACAO
        vm.items.nome_expedidora = response.data[0].EMEC_EXPEDIDORA
        vm.items.dt_expedicao = response.data[0].DT_EXP_DIPLOMA
        vm.items.num_expedicao = response.data[0].NUM_EXPEDICAO
        vm.items.nome_registradora = response.data[0].EMEC_REGISTRADORA
        vm.items.dt_registro = response.data[0].DT_REGISTRO
        vm.items.num_registro = response.data[0].NUM_REGISTRO
        vm.items.xml_publico = response.data[0].XML_PUBLICO
        vm.items.rvdd = response.data[0].RVDD

        if (response.data[0].SITUACAO_ITEM === 14) {
          vm.items.dt_erro_fato = formatShortDate(response.data[0].DT_ERRO_FATO)
          vm.items.hr_erro_fato = response.data[0].HR_ERRO_FATO
          vm.items.motivo_anulacao = response.data[0].MOTIVO

          vm.msgAnulacao = `O diploma de "${vm.items.nome}" foi anulado por erro de fato em ${vm.items.dt_erro_fato} às ${vm.items.hr_erro_fato}.`

          vm.anulErroFato = true
          vm.dDisable = false
        } else if (response.data[0].SITUACAO_ITEM >= 10 && response.data[0].SITUACAO_ITEM < 14) {
          vm.items.dt_erro_oficio = formatShortDate(response.data[0].DT_ERRO_OFICIO)
          vm.items.hr_erro_oficio = response.data[0].HR_ERRO_OFICIO

          vm.msgAnulacao = `O diploma de "${vm.items.nome}" está na situação "${vm.items.sit_diploma}" desde ${vm.items.dt_erro_oficio} às ${vm.items.hr_erro_oficio}.`

          vm.anulErroOficio = true
          vm.dDisable = false
        } else {
          if (response.data[0].DT_ATIVACAO != null && response.data[0].DT_ERRO_FATO != null) {
            vm.items.motivo_anulacao = response.data[0].MOTIVO
            let dtErroFato = formatShortDate(response.data[0].DT_ERRO_FATO)
            let dtAtivacao = formatShortDate(response.data[0].DT_ATIVACAO)
            vm.msgAnulacao = `Este diploma já esteve anulado por erro de fato no período entre ${dtErroFato} e ${dtAtivacao}.`
            vm.anulErroFatoAtivo = true
          }
        }

        if (response.data[0].SITUACAO_ITEM === 3) {
          vm.items.sit_diploma = 'Ativo'
        } else {
          vm.items.sit_diploma = 'Anulado'
        }
        // this.chkSelected !== 'codigo' ? vm.downloadsEnabled = false : vm.downloadsEnabled = true
        // if (vm.items.xml_publico == null && vm.items.rvdd == null) vm.downloadsEnabled = false
        // PERSONALIZADO POR CLIENTE
        if (this.instituicao) {
          let sigla = this.instituicao.COD_INSTITUICAO.trim()
          switch (sigla) {
            case 'UFT': // UFT JÁ DISSE QUE NÃO QUER O DOWNLOAD
              vm.downloadsEnabled = false
              break
            default:
              vm.downloadsEnabled = false
              break
          }
        }
      } else {
        vm.makeToast('danger', 'Nenhum diplomado encontrado.', 'Atenção')
      }
    },
    getLoaderPropriedades () {
      return {
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        color: '#17A2B8'
      }
    },
    rg (n) {
      if (n.length === 10) {
        let a = n.replace(/^(\d{2})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        return a
      } else if (n.length === 9) {
        let a = n.replace(/^(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4')
        return a
      } else {
        let a = n.replace(/^(\d{7})(\d{1})/, '$1-$2')
        return a
      }
    }
  },
  components: {axios}
}
</script>
<style scoped>
#g_pesquisa {
    margin-bottom: 15px;
}
#g_filtro {
    margin-bottom: 30px;
}
.line_dip {
    margin-top: 10px;
    margin-bottom: 10px;
}
.returnDados {
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/DadosDiploma.vue